/**
 * Widoczność zakładek na ekranie szczegółów terminu certyfikacji.
 */
export function resolveCertificationDetailTab(queryTab, tabVisibility) {
  if (queryTab === 'enrolments' && tabVisibility.enrolments) {
    return 'enrolments'
  }
  if (queryTab === 'invoices' && tabVisibility.invoices) {
    return 'invoices'
  }
  return 'info'
}

export function isUserEnrolledOnCertification(certificationData, userId) {
  if (!certificationData || userId == null) {
    return false
  }

  const ids = certificationData.enrolledUserIds || []
  return ids.some(enrolledId => String(enrolledId) === String(userId))
}

export function filterCertificationEnrolmentSlots(slots, flags) {
  const {
    isAdmin,
    isFordPoland,
    isTrainer,
  } = flags
  const allSlots = slots || []

  if (isAdmin || isFordPoland || isTrainer) {
    return allSlots
  }

  return allSlots.filter(slot => slot.enrolmentId)
}

// eslint-disable-next-line import/prefer-default-export
export function certificationDetailTabVisibility(flags) {
  const {
    isAdmin,
    isManager,
    isTrainer,
    isFordPoland,
    isEmployee,
    isCurrentUserEnrolled,
  } = flags

  const enrolmentsForStaff = isAdmin || isManager || isTrainer || isFordPoland
  const enrolmentsForEmployee = isEmployee && isCurrentUserEnrolled

  return {
    enrolments: enrolmentsForStaff || enrolmentsForEmployee,
    invoices: !!(isAdmin || isManager),
  }
}
